module.exports = __webpack_public_path__ + "static/img/default.6b914f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.jpg
// module id = HbUk
// module chunks = 1